import * as React from 'react';
import VersionNumber from '../../../VersionNumber';
import { LoginByPasswordOneCredentialRequireAuthKeyProps } from '@shopee-user/business-customization-types';

import styles from './style.scss';

function Footer(_: LoginByPasswordOneCredentialRequireAuthKeyProps) {
  return (
    <div className={styles.footer}>
      <VersionNumber />
    </div>
  );
}

export default Footer;
